import type { EntityState } from '../enums/EntityState'

export class ActivityLogFilterEntity {
  entityName!: string

  entityId!: string
  userId?: string
  state?: EntityState
  startTimeFrom?: string
  startTimeTo?: string
  isSucceeded?: boolean
  page?: number
  limit?: number
}
